import { StepFieldsMap } from 'sos-common/js/commonTypes/validation.types';
import { getFormConfig } from 'sos-eservice-common/js/config';
let _validationMap: StepFieldsMap;

export function setCurrentValidationMap(validationMap: StepFieldsMap) {
  _validationMap = validationMap;
}

export default function (): StepFieldsMap {
  if (!_validationMap) {
    _validationMap = getFormConfig().stepFieldsMap;
  }
  return _validationMap;
}
